import { WebApiService } from '../../../plugins/webApiService'
import { Events } from '../../../plugins/events'
import EventToAsyncDecorator from '../../../plugins/eventToAsyncDecorator'
import SearchFilterRequest from '../../../Spirit/Admin/Interfaces/Models/Common/SearchFilterRequest';
import AffirmationUpdateRequest from '../../../Spirit/Admin/Interfaces/Models/AfirmationSerivce/AffirmationUpdateRequest';
import ChangeSortIndexRequest from '../../../Spirit/Common/Helpers/Models/ChangeSortIndexRequest';
import WsResponseModelT from '../../../SchemaBuilderServer/Models/WsResponseModelT';
import AffirmationGetDetailResponse from '../../../Spirit/Admin/Interfaces/Models/AfirmationSerivce/AffirmationGetDetailResponse';
import PaginationResponseT from '../../../Common/ResponseModels/PaginationResponseT';
import AffirmationGetListResponse from '../../../Spirit/Admin/Interfaces/Models/AfirmationSerivce/AffirmationGetListResponse';

export default class AffirmationService {
	webApiService: WebApiService;
	DeleteEvent = new Events<WsResponseModelT<Boolean>>();
	GetDetailEvent = new Events<WsResponseModelT<AffirmationGetDetailResponse>>();
	GetListEvent = new Events<WsResponseModelT<PaginationResponseT<AffirmationGetListResponse>>>();
	UpdateEvent = new Events<WsResponseModelT<Boolean>>();
	ChangeSortIndexEvent = new Events<WsResponseModelT<Boolean>>();
	constructor(webApiService: WebApiService) {
		const self = this;
		this.webApiService = webApiService;
		webApiService.on('AffirmationService', 'Delete', (res: WsResponseModelT<Boolean>) => {
			self.DeleteEvent.trigger(res);
		});
		webApiService.on('AffirmationService', 'GetDetail', (res: WsResponseModelT<AffirmationGetDetailResponse>) => {
			self.GetDetailEvent.trigger(res);
		});
		webApiService.on('AffirmationService', 'GetList', (res: WsResponseModelT<PaginationResponseT<AffirmationGetListResponse>>) => {
			self.GetListEvent.trigger(res);
		});
		webApiService.on('AffirmationService', 'Update', (res: WsResponseModelT<Boolean>) => {
			self.UpdateEvent.trigger(res);
		});
		webApiService.on('AffirmationService', 'ChangeSortIndex', (res: WsResponseModelT<Boolean>) => {
			self.ChangeSortIndexEvent.trigger(res);
		});
	}
	Delete(id: number = 0) { 	
        this.webApiService.send('AffirmationService', 'Delete' , id);
    }
	GetDetail(id: number = 0) { 	
        this.webApiService.send('AffirmationService', 'GetDetail' , id);
    }
	GetList(request: SearchFilterRequest = null) { 	
        this.webApiService.send('AffirmationService', 'GetList' , request);
    }
	Update(request: AffirmationUpdateRequest = null) { 	
        this.webApiService.send('AffirmationService', 'Update' , request);
    }
	ChangeSortIndex(request: ChangeSortIndexRequest = null) { 	
        this.webApiService.send('AffirmationService', 'ChangeSortIndex' , request);
    }
	 // async methods
	async deleteAsync(id: number = 0): Promise<Boolean> {
		return EventToAsyncDecorator.getInstance().bind(this.Delete.bind(this), this.DeleteEvent)(id);
	}
	async getDetailAsync(id: number = 0): Promise<AffirmationGetDetailResponse> {
		return EventToAsyncDecorator.getInstance().bind(this.GetDetail.bind(this), this.GetDetailEvent)(id);
	}
	async getListAsync(request: SearchFilterRequest = null): Promise<PaginationResponseT<AffirmationGetListResponse>> {
		return EventToAsyncDecorator.getInstance().bind(this.GetList.bind(this), this.GetListEvent)(request);
	}
	async updateAsync(request: AffirmationUpdateRequest = null): Promise<Boolean> {
		return EventToAsyncDecorator.getInstance().bind(this.Update.bind(this), this.UpdateEvent)(request);
	}
	async changeSortIndexAsync(request: ChangeSortIndexRequest = null): Promise<Boolean> {
		return EventToAsyncDecorator.getInstance().bind(this.ChangeSortIndex.bind(this), this.ChangeSortIndexEvent)(request);
	}
}